import { render, staticRenderFns } from "./EventsCluster.vue?vue&type=template&id=2a157814&"
import script from "./EventsCluster.vue?vue&type=script&lang=js&"
export * from "./EventsCluster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports